<template>
  <RouterLink v-if="toRoute" :to="toRoute" class="font-semibold hover:underline">
    {{ LANGUAGES[toLang] }}
  </RouterLink>
</template>

<script lang="ts">
import { usePageStore } from '@/stores'

export default {
  name: 'LangSwitch',
  setup() {
    return {
      LANGUAGES: {
        en: 'English',
        fr: 'Français'
      } as Record<string, string>
    }
  },
  computed: {
    toLang() {
      return this.$i18n.availableLocales.filter(locale => locale !== this.$i18n.locale)[0]
    },
    toRoute() {
      if (!this.$route?.name) {
        return null
      }

      const targetRoute = {
        ...this.$route,
        name: this.$route.name.toString().replace(`:${this.$i18n.locale}`, `:${this.toLang}`),
      }

      if (!this.$route.name.toString().startsWith('page.show:')) {
        return targetRoute
      }

      const currentSlug = Array.isArray(this.$route.params.slug)
        ? this.$route.params.slug[0]
        : this.$route.params.slug

      if (!currentSlug) {
        return targetRoute
      }

      const page = Object.values(usePageStore().memory.index[this.$i18n.locale as 'fr' | 'en'] ?? {})
        .find(page => page?.slug?.fr === currentSlug || page?.slug?.en === currentSlug)

      const localizedSlug = page?.slug?.[this.toLang as 'fr' | 'en'] || currentSlug

      return {
        ...targetRoute,
        params: {
          ...this.$route.params,
          slug: localizedSlug,
        },
      }
    }
  }
}
</script>
